import lozad from 'lozad';

let observer;

export const init = () => {
  const PRODUCT_PRINTED = 'product-printed';

  CUBE.Analytics = CUBE.Analytics || {};
  CUBE.Analytics.enhanced.list = Object.assign({}, CUBE.Analytics.enhanced.list, {
    es6: {
      getProduct: element => {
        // Be sure to have a vanilla js element
        if (element.length) element = element[0];
        return element.closest('.dkt-product.js-product-slider-init');
      },
      getModelId: element => {
        const id = element.querySelector('.dkt-product-slider__slide--active');
        return (id) ? parseInt(id.dataset.referenceId, 10) : 0;
      },
      getName: element => element.querySelector('.dkt-product__title').textContent.trim(),
      getPrice: element => parseInt(element.querySelector('.dkt-price__cartridge[data-price]').dataset.price.trim(), 10),
      getBrand: element => {
        const result = element.querySelector('.dkt-product__brand').textContent.trim();
        return (result) ? CUBE.Analytics.enhanced.list.es6.getRealBrandName(result) : '';
      },
      getPosition: element => Array.from(document.querySelectorAll('.dkt-product.js-product-slider-init')).indexOf(element) + 1,
      getVada: element => {
        const dataset = element.dataset;
        return {
          family: dataset.vadaFamily || '',
          department: dataset.vadaDepartment || '',
          subdepartment: dataset.vadaSubdepartment || '',
          universe: dataset.vadaUniverse || ''
        }
      },
      getRealBrandName: brand => {
        let result = brand;
        if (/^[a-z]{1}_(.*)/.test(brand)) {
          result = brand.substr(2);
        }
        return result.toUpperCase();
      },

      setProductAsPrinted: element => element.classList.add(PRODUCT_PRINTED),

      productIsPrinted: element => element.classList.contains(PRODUCT_PRINTED),

      /**
       * Builds a MODEL object
       */
      getSelectedModel: (element) => {
        element = CUBE.Analytics.enhanced.list.es6.getProduct(element);
        const vada = CUBE.Analytics.enhanced.list.es6.getVada(element);

        return {
          type: 'product',
          id: CUBE.Analytics.enhanced.list.es6.getModelId(element),
          name: CUBE.Analytics.enhanced.list.es6.getName(element),
          brand: CUBE.Analytics.enhanced.list.es6.getBrand(element),
          position: CUBE.Analytics.enhanced.list.es6.getPosition(element),
          list: `${CUBE.Analytics.utils.getInfoNavFromURLForEnhancedEcommerce(document.location.pathname + document.location.search)}`,
          price: CUBE.Analytics.enhanced.list.es6.getPrice(element),
          variant: element.dataset.nature.trim(),
          category: `${vada.universe}/${vada.department}/${vada.subdepartment}/${vada.family}`,
          sticker: '',
          vada
        };
      },

      /**
       * Executed when a product is visible in viewport
       */
      sendImpression: (element) => {
        const model = CUBE.Analytics.enhanced.list.es6.getSelectedModel(element);
        element = CUBE.Analytics.enhanced.list.es6.getProduct(element);

        if (!CUBE.Analytics.enhanced.list.es6.productIsPrinted(element)) {
          CUBE.Analytics.enhanced.list.es6.setProductAsPrinted(element);
          CUBE.Analytics.enhanced.sendImpression(model);
        };
      },

      initImpression: () => {
        observer = lozad(`article.dkt-product.js-product-slider-init`, {
          threshold: 0.5,
          loaded: element => {
            if (!element) return;
            CUBE.Analytics.enhanced.list.es6.sendImpression(element);
          }

        });

        CUBE.Analytics.enhanced.list.es6.updateObserver();
      },

      /**
       * Function to update the lazyObserver after a DOM change / insertion
       *
       */
      updateObserver: () => {
        if (observer && observer.observe) {
          observer.observe();
        } else {
          console.warn('Lazyload : lazyObserver was not correctly initialized !');
        }
      }

    }
  });
};



// WEBPACK FOOTER //
// ./src/analytics/framework/utils/list.js